import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { isEmpty } from '@/shared/helpers';
import { getAllPrograms } from '@/shared/apiHelper.jsx';
import CoCardReportDataTable from './components/CoCardReportDataTable';

const CoCardReport = () => {
  const [defaultPrograms, setDefaultPrograms] = useState([]);
  const { programId } = useParams();

  useEffect(() => {
    if (isEmpty(defaultPrograms)) {
      getAllPrograms('minimal=true&limit=99999999&programId=' + programId).then((response) => {
        const data = response?.data ? response.data : [];
        setDefaultPrograms(data.map((x) => x.account_holder_id));
      });
    }
  });

  if (isEmpty(defaultPrograms)) return <p>Loading...</p>;

  return <CoCardReportDataTable programs={defaultPrograms} />;
};

export default CoCardReport;
